module.exports = __webpack_public_path__ + "img/1472572734.5167592a.jpg";